import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import AllReturnRequests from './all-return-requests';
import ReturnRequestDetails from './return-request-details';
import InitiateRefund from './Initiate-refund';
import OrderRefundDetails from './order-refund-details';
import { PageTitle } from '../../../umart_admin/layout/core';

const Index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        <Route
          index
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Inventory',
                    path: '#',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Return Requests
              </PageTitle>
              <AllReturnRequests />
            </>
          }
        />
        <Route
          path="/return-request-details"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Inventory',
                    path: '#',
                    isSeparator: false,
                    isActive: false,
                  },
                  {
                    title: 'Return Requests',
                    path: '/all-return-requests',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Return Request Details
              </PageTitle>
              <ReturnRequestDetails />
            </>
          }
        />
        <Route
          path="/order-refund-details"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Inventory',
                    path: '#',
                    isSeparator: false,
                    isActive: false,
                  },
                  {
                    title: 'Return Requests',
                    path: '/all-return-requests',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Order Refund Details
              </PageTitle>
              <OrderRefundDetails />
            </>
          }
        />
        <Route
          path="/initiate-refund"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Inventory',
                    path: '#',
                    isSeparator: false,
                    isActive: false,
                  },
                  {
                    title: 'Return Requests',
                    path: '/all-return-requests',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Initiate Refund
              </PageTitle>
              <InitiateRefund />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default Index;
